<template>
    <aside ref="aside" class="side-menu">
        <div ref="mordalenta" class="morda-lenta-side">
            <mordaLentaButtonFund></mordaLentaButtonFund>
        </div>
        <!--        <div ref="indicator" class="indicator"></div>-->
        <div
            ref="nav"
            v-click-outside="{
                exclude: ['menuOpener'],
                handler: 'hideMobileMenu',
            }"
            id="nav"
            class="side-nav-wrapper"
            :class="{
                fixed: menuFixed,
                'mobile-open': menuMobileOpen,
            }"
        >
            <nav
                class="side-nav"
                :data-theme="userIsEmpty('user') == true ? 'unauth' : 'auth'"
            >
                <ul class="side-list">
                    <li class="side-nav-mobile">
                        <div class="side-nav-user">
                            <div
                                :style="{
                                    'background-image': user.avatar
                                        ? 'url(' + user.avatar + ')'
                                        : '',
                                }"
                                :class="{ 'no-avatar': !user.avatar }"
                                class="side-nav-avatar"
                            ></div>
                            <div class="side-nav-name-info">
                                <div class="side-nav-name">
                                    {{ user.first_name }}
                                    {{ user.last_name }}
                                </div>
                                <router-link
                                    :to="{
                                        name: 'profile',
                                        params: { id: user.id },
                                    }"
                                    style="
                                        font-size: 14px;
                                        text-decoration: none;
                                        color: #000;
                                        opacity: 0.8;
                                        margin-top: 16px;
                                        display: flex;
                                    "
                                >
                                    Перейти в профиль
                                </router-link>
                            </div>
                        </div>
                        <button
                            @click="logout"
                            class="button button-border-red side-nav-logout"
                        >
                            {{ $t("header.headerLogOut") }}
                        </button>
                    </li>
                    <redirectButton
                        tag="li"
                        pathname="home"
                        :html="linkHtml($t('sideMenu.ribbon'))"
                        class="side-nav-item side-nav-desktop"
                    ></redirectButton>
                    <redirectButton
                        tag="li"
                        pathname="search"
                        :html="linkHtml($t('sideMenu.people'))"
                        class="side-nav-item side-nav-desktop"
                    ></redirectButton>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="profile"
                        :params="{ id: user.id }"
                        :html="linkHtml($t('sideMenu.myProfile'))"
                        class="side-nav-item side-nav-desktop"
                    ></redirectButton>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="my-puzzles"
                        :params="{ profileId: user.id }"
                        :html="linkHtml($t('sideMenu.myPuzzles'))"
                        class="side-nav-item side-nav-item-myPuzzles"
                    ></redirectButton>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="albums"
                        :params="{ profileId: user.id }"
                        :html="linkHtml($t('sideMenu.myPhotos'))"
                        class="side-nav-item side-nav-item-myPhotos"
                    ></redirectButton>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="video-albums"
                        :params="{ profileId: user.id }"
                        :html="linkHtml($t('sideMenu.myVideos'))"
                        class="side-nav-item side-nav-item-myVideos"
                    ></redirectButton>
                    <router-link
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        :to="{ name: 'threads' }"
                        class="side-nav-item side-nav-item-threads"
                    >
                        <a class="side-nav-link">
                            <span>{{ $t("sideMenu.messages") }}</span>
                            <span
                                v-if="
                                    !initIsEmpty('init') &&
                                    init.counters &&
                                    init.counters.messages > 0
                                "
                                class="side-nav-new"
                                >{{ init.counters.messages }}</span
                            >
                        </a>
                    </router-link>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="my_friends"
                        :html="linkHtml($t('sideMenu.myFriends'))"
                        class="side-nav-item side-nav-item-myFriends"
                    ></redirectButton>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="games"
                        :html="linkHtml($t('sideMenu.games'))"
                        class="side-nav-item side-nav-item-games"
                    ></redirectButton>

                    <redirectButton
                        tag="li"
                        pathname="horoscope"
                        :html="linkHtml($t('sideMenu.horoscope'))"
                        class="side-nav-item side-nav-item-horoscope"
                    ></redirectButton>

                    <router-link
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        :to="{ name: 'events' }"
                        class="side-nav-item side-nav-item-events"
                    >
                        <a class="side-nav-link">
                            <span>{{ $t("sideMenu.events") }}</span>
                            <span
                                v-if="
                                    !initIsEmpty('init') &&
                                    init.counters &&
                                    init.counters.events > 0
                                "
                                class="side-nav-new"
                                >{{ init.counters.events }}</span
                            >
                        </a>
                    </router-link>

                    <redirectButton
                        v-if="!userIsEmpty('user')"
                        tag="li"
                        pathname="stories"
                        :html="linkHtml($t('sideMenu.stories'))"
                        class="side-nav-item side-nav-item-stories"
                    ></redirectButton>

                    <!-- <redirectButton
            v-if="!userIsEmpty('user')"
            tag="li"
            pathname="settings"
            :html="linkHtml($t('sideMenu.settings'))"
            class="side-nav-item"
          ></redirectButton> -->

          <redirectButton
            v-if="menuMobileOpen"
            tag="li"
            pathname="settings"
            :html="linkHtml($t('sideMenu.settings'))"
            class="side-nav-item"
          ></redirectButton>
        </ul>
        <div class="market-links">
          <a href="https://appgallery.huawei.com/#/app/C113940915" target="_blank"><img src="../assets/img/market_links/appGallery.jpg" alt="Ошибка загрузки изображения"></a>
          <a href="https://play.google.com/store/apps/details?id=ru.ludivpluse.app&hl=ru" target="_blank"><img src="../assets/img/market_links/googlePlay.jpg" alt="Ошибка загрузки изображения"></a>
          <a href="https://www.rustore.ru/catalog/app/ru.ludivpluse.app?_rsc=45uml" target="_blank"><img src="../assets/img/market_links/ruStore.jpg" alt="Ошибка загрузки изображения"></a>
        </div>
      </nav>
      <!-- <div class="side-theme-picker">
                <div class="side-title">Обои</div>
                <ul
                    class="side-theme-list"
                >
                    <li
                        v-for="theme in themes"
                        @click="selectTheme(theme.id)"
                        class="side-theme-item picker-item"
                        :class="{selected: theme.id == currentTheme}"
                    >
                        <div
                            :style="{
                                'background-color': theme.primary
                            }"
                            class="half"
                        ></div>
                        <div
                            :style="{
                                'background-color': theme.secondary
                            }"
                            class="half"
                        ></div>
                    </li>
                </ul>
            </div> -->
            <nav class="side-footer">
                <div class="side-lang">
                    <div v-click-outside="{
                        handler: 'hideLanguageSelect',
                    }" class="header-language-select side-menu-select">
                        <div>Язык интерфейса:</div>
                        <button @click="isOpen = !isOpen">
                            {{ currentLanguage }}
                        </button>
                        <div class="options" v-show="isOpen">
                            <div
                                class="option"
                                v-for="(lang, index) in languages"
                                :key="index"
                                @click="selectLanguage(lang.code)"
                            >
                                {{ lang.label }}
                            </div>
                        </div>
                    </div>
                </div>
                <ul class="side-footer-menu">
                    <li class="side-footer-item">
                        <redirectButton
                            pathname="about"
                            :html="linkHtml($t('footer.footerAbout'))"
                            class="side-footer-link"
                        ></redirectButton>
                    </li>
                    <li class="side-footer-item">
                        <redirectButton
                            pathname="rules"
                            :html="linkHtml($t('footer.footerRules'))"
                            class="side-footer-link"
                        ></redirectButton>
                    </li>
                    <li class="side-footer-item">
                        <redirectButton
                            pathname="help"
                            :html="linkHtml($t('footer.footerHelps'))"
                            class="side-footer-link"
                        ></redirectButton>
                    </li>
                    <li class="side-footer-item">
                        <redirectButton
                            pathname="legal"
                            :html="linkHtml($t('footer.footerLegal'))"
                            class="side-footer-link"
                        ></redirectButton>
                    </li>
                    <li class="side-footer-item">
                        <redirectButton
                            pathname="feedback"
                            :html="linkHtml($t('footer.footerFeedback'))"
                            class="side-footer-link"
                        ></redirectButton>
                    </li>
                    <!-- <li class="side-footer-item">
                        <redirectButton
                            pathname="advertising"
                            html="Реклама"
                            class="side-footer-link"
                        ></redirectButton>
                    </li>
                    <li class="side-footer-item">
                        <redirectButton
                            pathname="developers"
                            html="Разработчикам"
                            class="side-footer-link"
                        ></redirectButton>
                    </li> -->
                    <!-- <li class="side-footer-item side-footer-item-developer">
            <a href="http://my-green.ru/"></a>
          </li> -->
                </ul>
            </nav>
        </div>
        <nav class="mobile-nav">
            <ul class="mobile-menu container-mobile">
                <router-link
                    v-if="!userIsEmpty('user')"
                    tag="li"
                    :to="{ name: 'profile', params: { id: user.id } }"
                    class="mobile-menu-item mobile-menu-profile"
                >
                    <div
                        :style="{
                            'background-image': user.avatar
                                ? 'url(' + user.avatar + ')'
                                : '',
                        }"
                        :class="{ 'no-avatar': !user.avatar }"
                        class="mobile-menu-avatar"
                    ></div>
                </router-link>
                <router-link
                    tag="li"
                    :to="{ name: 'home' }"
                    class="mobile-menu-item mobile-menu-feed"
                ></router-link>
                <router-link
                    v-if="!userIsEmpty('user')"
                    tag="li"
                    :to="{ name: 'threads' }"
                    class="mobile-menu-item mobile-menu-messages"
                >
                    <span
                        v-if="
                            !initIsEmpty('init') &&
                            init.counters &&
                            init.counters.messages > 0
                        "
                        class="mobile-menu-notification"
                        >{{ init.counters.messages }}</span
                    >
                </router-link>
                <router-link
                    tag="li"
                    :to="{ name: 'search' }"
                    class="mobile-menu-item mobile-menu-search"
                ></router-link>
                <router-link
                    v-if="userIsEmpty('user')"
                    tag="li"
                    :to="{ name: 'horoscope' }"
                    class="mobile-menu-item mobile-menu-horoscope"
                ></router-link>
                <router-link
                    v-if="!userIsEmpty('user')"
                    tag="li"
                    :to="{ name: 'my_friends' }"
                    class="mobile-menu-item mobile-menu-friends"
                ></router-link>
                <li
                    v-if="!userIsEmpty('user')"
                    @click="menuMobileOpen = !menuMobileOpen"
                    ref="menuOpener"
                    class="mobile-menu-item mobile-menu-burger"
                >
                    <span
                        v-if="
                            !initIsEmpty('init') &&
                            init.counters &&
                            init.counters.events > 0
                        "
                        class="mobile-menu-notification"
                        >{{ init.counters.events }}</span
                    >
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import mordaLentaButtonFund from "@/components/Blocks/MordaLentaButtonFund";
import Vue from "vue";
// import advertisingMenu from "./Blocks/AdvertisingMenu.vue";

export default {
    name: "SideMenu",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
        mordaLentaButtonFund,
        // advertisingMenu,
    },
    data() {
        return {
            menuFixed: false,
            menuMobileOpen: false,
            isOpen: false,
            languages: [
                { code: "ru", label: "Русский" },
                { code: "en", label: "English" },
                { code: "tr", label: "Turkish" },
                { code: "es", label: "Spanish" },
                { code: "fr", label: "French" },
            ],
        };
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.menuMobileOpen = false;
            }
        },
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            themes: "themes/fetchThemes",
            currentTheme: "themes/fetchCurrentTheme",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
        }),
        currentLanguage() {
            const lang = this.$i18n.locale;
            const current = this.languages.find((l) => l.code === lang);
            return current.label;
        },
    },
    created() {
        // let nav, target;
        // let options = {
        //     rootMargin: '0px',
        //     threshold: 1.0
        // }
        // let callback = (entries, observer) => {
        //     if(entries[0].isIntersecting === true) {
        //         this.menuFixed = false;
        //     } else {
        //         this.menuFixed = true;
        //     }
        // };
        // let observer = new IntersectionObserver(callback, options);
        // setTimeout(() => {
        //     target = this.$refs.indicator;
        //     nav = this.$refs.nav;
        //     if (nav && target) {
        //         observer.observe(target);
        //     }
        //     this.setMinHeight();
        // }, 300);
        // window.addEventListener('resize', this.setMinHeight);
    },
    // beforeDestroy() {
    // window.removeEventListener('resize', this.setMinHeight);
    // },
    methods: {
        selectLanguage(langCode) {
            this.$i18n.locale = langCode;
            this.isOpen = false;
            localStorage.setItem("locale", langCode);
        },
        selectTheme(id) {
            if (id == this.currentTheme) {
                return;
            }

            this.$store.dispatch("themes/setTheme", id);
        },
        hideMobileMenu() {
            this.menuMobileOpen = false;
        },
        // setMinHeight() {
        //     let aside = this.$refs.aside;
        //     if (window.innerWidth < 992) {
        //         aside.style.height = 'auto';
        //     } else {
        //         aside.style.height = (
        //             this.$refs.mordalenta.clientHeight +
        //             this.$refs.nav.clientHeight + 14
        //         ) + 'px';
        //     }
        // },
        logout() {
            const vm = new Vue();
            this.$store.dispatch("user/logout").then(() => {
                this.$router.push({ name: "home" });
                vm.$disconnect();
            });
        },
        linkHtml(text) {
            return '<a class="side-nav-link">' + text + "</a>";
        },
        hideLanguageSelect() {
            this.isOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_picker-item";
@import "~@/assets/styles/layout/_side-menu";
@import "~@/assets/styles/layout/_header";

.side-menu-select-desktop {
    flex-direction: row;
    flex-wrap: wrap;
}
.side-menu-select-text-desktop {
    width: 100%;
    margin-bottom: 12px;
}
.side-menu-select-button-desktop {
    width: 133px;
}
</style>
